"use client";
import { useState } from "react";
import Image from "next/image";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

export default function EventGallery({ images }) {
  const [openLightbox, setOpenLightbox] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!images?.length) return null;

  const slides = images.map((img) => ({
    src: img.formats?.large?.url || img.formats?.medium?.url || img.url,
  }));

  return (
    <>
      <section className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto mt-10">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <span className="w-1 h-5 rounded-full bg-[#005D82]" />
            <h2 className="text-[22px] font-bold text-gray-900">Event Gallery</h2>
          </div>
          <span className="text-[11px] font-medium text-[#005D82] bg-[#dee9f2] px-3 py-1 rounded-full">
            {images.length} Photos
          </span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
          {images.map((img, i) => {
            const url = img.formats?.medium?.url || img.formats?.large?.url || img.url;

            return (
              <div
                key={img.id}
                className="group relative w-full h-60 rounded overflow-hidden cursor-pointer"
                onClick={() => {
                  setCurrentIndex(i);
                  setOpenLightbox(true);
                }}
              >
                {/* blurred background */}
                <Image src={url} alt="bg" fill className="object-cover blur-lg scale-110" aria-hidden />

                {/* sharp contained image */}
                <Image
                  src={url}
                  alt={img.name || `Event photo ${i + 1}`}
                  fill
                  className="object-contain transition-transform duration-300 group-hover:scale-[1.03]"
                />

                {/* hover blue overlay */}
                <div className="absolute inset-0 bg-[#005D82]/0 group-hover:bg-[#005D82]/12 transition-all duration-300 border border-transparent group-hover:border-[#005D82]/30 rounded" />

                {/* zoom icon */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-9 h-9 rounded-full bg-white/90 flex items-center justify-center shadow-sm">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#005D82" strokeWidth="2" strokeLinecap="round">
                      <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
                    </svg>
                  </div>
                </div>

                {/* number badge on hover */}
                <div className="absolute top-2 left-2 opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="text-[10px] font-bold bg-[#005D82] text-white px-2 py-0.5 rounded">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <Lightbox
        open={openLightbox}
        close={() => setOpenLightbox(false)}
        index={currentIndex}
        slides={slides}
      />
    </>
  );
}
